/* Liquid Rails — hero slideshow drag-to-slide
   Lets visitors drag the homepage hero slider with a mouse (grab/grabbing cursor).
   Dawn's slideshow track is a horizontal scroll container with CSS scroll-snap. We
   disable snap during the drag so the track follows the cursor smoothly, then snap to
   the nearest slide on release. Pointer capture keeps move events flowing even when the
   cursor passes over slide images/links. Touch swipe already works natively. */
(function () {
  function enableDrag(slider) {
    if (!slider || slider.dataset.lrDragReady) return;
    slider.dataset.lrDragReady = 'true';

    var isDown = false;
    var startX = 0;
    var startScroll = 0;
    var moved = false;
    var savedSnap = '';

    function slideWidth() {
      var first = slider.querySelector('.slideshow__slide, .slideshow__media, .slide');
      return first ? first.getBoundingClientRect().width : slider.clientWidth;
    }

    slider.addEventListener('pointerdown', function (e) {
      if (e.button && e.button !== 0) return;
      isDown = true;
      moved = false;
      startX = e.pageX;
      startScroll = slider.scrollLeft;
      savedSnap = slider.style.scrollSnapType;
      slider.style.scrollSnapType = 'none'; // let the track follow the cursor
      slider.classList.add('is-dragging');
      try { slider.setPointerCapture(e.pointerId); } catch (err) {}
    });

    slider.addEventListener('pointermove', function (e) {
      if (!isDown) return;
      var delta = e.pageX - startX;
      if (Math.abs(delta) > 4) moved = true;
      slider.scrollLeft = startScroll - delta;
      e.preventDefault();
    });

    function end(e) {
      if (!isDown) return;
      isDown = false;
      slider.classList.remove('is-dragging');
      slider.style.scrollSnapType = savedSnap;
      // Snap to the nearest slide.
      var w = slideWidth();
      if (w > 0) {
        var index = Math.round(slider.scrollLeft / w);
        slider.scrollTo({ left: index * w, behavior: 'smooth' });
      }
      try { if (e && e.pointerId != null) slider.releasePointerCapture(e.pointerId); } catch (err) {}
    }

    slider.addEventListener('pointerup', end);
    slider.addEventListener('pointercancel', end);

    // Suppress the click that would fire on a button/link at the end of a drag.
    slider.addEventListener('click', function (e) {
      if (moved) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);

    // Don't let the browser start a native image drag.
    slider.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }

  function init() {
    document
      .querySelectorAll('slideshow-component .slideshow, .slideshow.banner')
      .forEach(enableDrag);
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
